const calculateNetRecurringBenefits = (initiatives) => {
  if (!Array.isArray(initiatives)) return {};

  const groups = {
    '<not set>': [],
    'No value': [],
    'Negative value': [],
    'ETB 0-ETB 1Mn': [],
    'ETB 1Mn-ETB 10Mn': [],
    'ETB 10Mn-ETB 50Mn': [],
    'ETB 50Mn-ETB 100Mn': [],
    'ETB 100Mn-ETB 500Mn': [],
    'ETB 500Mn-ETB 1Bn': [],
    '>ETB 1Bn': [],
  };

  const sumAnnualizedValue = (impact, stage) => {
    const values = impact?.annualizedValues?.plan;


    if (typeof values === 'number') return values;
    if (Array.isArray(values)) return values.reduce((sum, v) => sum + (v || 0), 0);
    return 0;
  };

  for (const initiative of initiatives) {
    const impacts = initiative.impact || [];
    const stage = initiative.stage;

    let totalRecurringBenefit = 0;
    let totalNegativeImpact = 0;

    for (const impact of impacts) {
      const value = sumAnnualizedValue(impact, stage);
      if (impact.frequencyAndDirection === 'Recurring Benefit (ETB)') {
        totalRecurringBenefit += value;
      } else if (impact.frequencyAndDirection === 'Recurring Negative Impact (ETB)') {
        totalNegativeImpact += value;
      }
    }

    const netBenefit = totalRecurringBenefit - totalNegativeImpact;

    // Handle cases where initiative has no financial impact data
    if (!initiative.hasFinancialImpact || impacts.length === 0) {
      groups['No value'].push(initiative);
      continue;
    }

    // Handle negative values
    if (netBenefit < 0) {
      groups['Negative value'].push(initiative);
      continue;
    }

    // Categorize positive values
    if (netBenefit === 0) {
      groups['ETB 0-ETB 1Mn'].push(initiative);
    } else if (netBenefit > 0 && netBenefit <= 1) {
      groups['ETB 0-ETB 1Mn'].push(initiative);
    } else if (netBenefit <= 10) {
      groups['ETB 1Mn-ETB 10Mn'].push(initiative);
    } else if (netBenefit <= 50) {
      groups['ETB 10Mn-ETB 50Mn'].push(initiative);
    } else if (netBenefit <= 100) {
      groups['ETB 50Mn-ETB 100Mn'].push(initiative);
    } else if (netBenefit <= 500) {
      groups['ETB 100Mn-ETB 500Mn'].push(initiative);
    } else if (netBenefit <= 1000) {
      groups['ETB 500Mn-ETB 1Bn'].push(initiative);
    } else {
      groups['>ETB 1Bn'].push(initiative);
    }
  }

  return groups;
};

export default calculateNetRecurringBenefits;